import PropTypes from 'prop-types'
import classnames from 'classnames'
import { RadioGroup, Radio } from 'components/forms'
import { StarRating } from 'baby-design'
import { InlineCounter, FilterSection } from './filter-section'
import { getFilteredProductsCount, SECTIONS, FILTERS } from '../../helpers'

export const RatingFilterSection = ({
  open,
  products,
  minRating,
  setMinRating,
  selfExcludingFilters,
}) => {
  const count5 = getFilteredProductsCount(products, {
    ...selfExcludingFilters,
    [FILTERS.MIN_RATING]: 5,
  })
  const count4 = getFilteredProductsCount(products, {
    ...selfExcludingFilters,
    [FILTERS.MIN_RATING]: 4,
  })
  const count3 = getFilteredProductsCount(products, {
    ...selfExcludingFilters,
    [FILTERS.MIN_RATING]: 3,
  })
  const count2 = getFilteredProductsCount(products, {
    ...selfExcludingFilters,
    [FILTERS.MIN_RATING]: 2,
  })
  const count1 = getFilteredProductsCount(products, {
    ...selfExcludingFilters,
    [FILTERS.MIN_RATING]: 1,
  })
  return (
    <FilterSection
      collapsedContent={
        minRating ? (
          <StarRating rating={minRating} reviewCount={0} />
        ) : undefined
      }
      open={open}
      title={SECTIONS.RATING}
    >
      <RadioGroup>
        <Radio
          checked={!minRating}
          label={
            <div>
              <span>{`Show All ${SECTIONS.RATING}s`}</span>
              <InlineCounter count={products.length} />
            </div>
          }
          size="large"
          onChange={() => setMinRating(undefined)}
        />
        <Radio
          checked={minRating === 5}
          disabled={count5 === 0}
          label={
            <div className={classnames({ disabled: count5 === 0 })}>
              <span>
                5{' '}
                <StarRating className="inline mlm" rating={5} reviewCount={0} />
              </span>
              <InlineCounter count={count5} />
            </div>
          }
          size="large"
          onChange={() => setMinRating(5)}
        />
        <Radio
          checked={minRating === 4}
          disabled={count4 === 0}
          label={
            <div className={classnames({ disabled: count4 === 0 })}>
              <span>
                4 & up{' '}
                <StarRating className="inline mlm" rating={4} reviewCount={0} />
              </span>
              <InlineCounter count={count4} />
            </div>
          }
          size="large"
          onChange={() => setMinRating(4)}
        />
        <Radio
          checked={minRating === 3}
          disabled={count3 === 0}
          label={
            <div className={classnames({ disabled: count3 === 0 })}>
              <span>
                3 & up{' '}
                <StarRating className="inline mlm" rating={3} reviewCount={0} />
              </span>
              <InlineCounter count={count3} />
            </div>
          }
          size="large"
          onChange={() => setMinRating(3)}
        />
        <Radio
          checked={minRating === 2}
          disabled={count2 === 0}
          label={
            <div className={classnames({ disabled: count2 === 0 })}>
              <span>
                2 & up{' '}
                <StarRating className="inline mlm" rating={2} reviewCount={0} />
              </span>
              <InlineCounter count={count2} />
            </div>
          }
          size="large"
          onChange={() => setMinRating(2)}
        />
        <Radio
          checked={minRating === 1}
          disabled={count1 === 0}
          label={
            <div className={classnames({ disabled: count1 === 0 })}>
              <span>
                1 & up{' '}
                <StarRating className="inline mlm" rating={1} reviewCount={0} />
              </span>
              <InlineCounter count={count1} />
            </div>
          }
          size="large"
          onChange={() => setMinRating(1)}
        />
      </RadioGroup>
    </FilterSection>
  )
}

RatingFilterSection.propTypes = {
  minRating: PropTypes.number,
  open: PropTypes.bool.isRequired,
  products: PropTypes.array.isRequired,
  setMinRating: PropTypes.func.isRequired,
  selfExcludingFilters: PropTypes.object.isRequired,
}

RatingFilterSection.defaultProps = {
  minRating: undefined,
}
